// InteractionTimeline — Chronological list of interactions
import { Mail, Phone, Calendar, FileText, MoreHorizontal } from 'lucide-react'
import type { CrmInteraction } from '../../types'

const ICON_MAP = {
  email: Mail,
  call: Phone,
  meeting: Calendar,
  note: FileText,
  other: MoreHorizontal,
}

const COLOR_MAP = {
  email: 'bg-blue-50 text-blue-600',
  call: 'bg-green-50 text-green-600',
  meeting: 'bg-purple-50 text-purple-600',
  note: 'bg-amber-50 text-amber-600',
  other: 'bg-gray-50 text-gray-600',
}

interface Props {
  interactions: CrmInteraction[]
}

export default function InteractionTimeline({ interactions }: Props) {
  if (interactions.length === 0) {
    return <p className="text-sm text-gray-500 text-center py-8">No interactions recorded</p>
  }

  const sorted = [...interactions].sort((a, b) =>
    new Date(b.interaction_date || b.created_at).getTime() - new Date(a.interaction_date || a.created_at).getTime()
  )

  return (
    <div className="space-y-3">
      {sorted.map((i) => {
        const Icon = ICON_MAP[i.interaction_type] || FileText
        const color = COLOR_MAP[i.interaction_type] || COLOR_MAP.other
        return (
          <div key={i.interaction_id} className="flex gap-3">
            <div className={`w-8 h-8 rounded-full flex items-center justify-center flex-shrink-0 ${color}`}>
              <Icon size={14} />
            </div>
            <div className="flex-1 bg-white border rounded-lg p-3">
              <div className="flex items-center gap-2 mb-1">
                <span className="text-xs bg-gray-100 text-gray-600 px-2 py-0.5 rounded capitalize">{i.interaction_type}</span>
                <span className="text-xs text-gray-500">{new Date(i.interaction_date || i.created_at).toLocaleDateString()}</span>
              </div>
              {i.subject && <p className="text-sm font-medium text-gray-900">{i.subject}</p>}
              {i.body && <p className="text-sm text-gray-600 mt-1">{i.body}</p>}
            </div>
          </div>
        )
      })}
    </div>
  )
}
